import useFiltersVariables from "components/Filters/useFiltersVariables";

import {
  STACK_TASKS_FILTER_TYPE,
  STACK_TASKS_INITIAL_SORT_DIRECTION,
  STACK_TASKS_INITIAL_SORT_OPTION,
} from "./constants";

const useStackTasksFiltersVariables = () => {
  const { filterVariables, filterVariablesLoaded } = useFiltersVariables({
    filterType: STACK_TASKS_FILTER_TYPE,
    initialSortDirection: STACK_TASKS_INITIAL_SORT_DIRECTION,
    initialSortOption: STACK_TASKS_INITIAL_SORT_OPTION,
  });

  return {
    fullTextSearch: filterVariables.searchInput,
    sortOptionFields: filterVariables.sortOptionFields,
    filterVariablesLoaded,
  };
};

export default useStackTasksFiltersVariables;
